import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./button.css.ts.vanilla.css-mistica.js";
import "./button-layout.css.ts.vanilla.css-mistica.js";
var y = {
    right: "kfxylh8 _1y2v1nfhu",
    left: "kfxylh9 _1y2v1nfhs",
    center: "kfxylha _1y2v1nfht",
    "full-width": "kfxylhb _1y2v1nfht"
}, l = "kfxylh2 _1y2v1nfhk _1y2v1nfhz", i = "kfxylh3", k = "kfxylhe kfxylhd _1y2v1nfhk _1y2v1nfi7", r = "kfxylhf kfxylhd _1y2v1nfhk _1y2v1nfi7", t = "kfxylh0";
export { y as alignVariant, l as container, i as containerWithTwoButtons, k as link, r as linkInNewLine, t as margins };
